class FunnelPage extends HTMLElement {
  constructor() {
    super();

    this.subtotal = 0;
    this.subtotalArray = [];
    this.isNonGiftProductAlreadyAddedToTheCart = false;
    this.isGiftCriteriaConsistent = false;
    this.sellingPlan = null;
    this.selectedVariantTitle = '';
    this.selectedVariantId = null;
    this.availableQty = 1;
    this.oneTimeAvailableQty = this.dataset.oneTimeQty;
    this.bundleAvailableQty = this.dataset.bundleQty;
    this.membershipAvailableQty = this.dataset.membershipQty;
    this.ingardenColorElement = this.querySelectorAll('input[name="variant"]');
    this.productFilterButton = this.querySelector('.funnel-step__funnel-filters');

    this.productFilterBody = this.querySelector('#funnel-filters-drawer');
    this.productFilterButtonClose = this.querySelector('#FilterDrawerClose');
    this.productFiltersShowActive = this.querySelector('.funnel-step__funnel-active-filters');
    this.productFilterCheckBox = this.querySelectorAll('.funnel-filters-drawer input[type="checkbox"]');
    this.productFilterSaveButton = this.querySelector('.funnel-step__funnel-filters-wrap [data-save]');
    this.productFilterResetButton = this.querySelector('.funnel-step__funnel-filters-wrap [data-reset]');
    this.activeProductFilter = [];
    this.activeProducts = [];

    this.nextButton = this.querySelector('[data-next]');
    this.backButton = this.querySelector('[data-back]');
    this.checkoutButton = this.querySelector('[data-checkout]');
    this.currentStepElement = this.querySelector('[data-current-step]');
    this.funnelProcessElement = this.querySelector('.funnel-page__progress');
    this.wrapperElement = this.querySelector('[data-wrapper]');
    this.subtotalElement = this.querySelector('[data-subtotal]');
    this.notGiftProductQuantity = 0;

    this.footerElement = this.querySelector('footer');

    this.currentStep = 0;
    this.localStep = 0;
    this.funnelStep = 0;
    this.planPricesInit = false;
    this.lastStep = this.querySelectorAll('[data-step]').length - 1;
    this.subscriptionStep = +this.querySelector('.subscription-switcher').closest('[data-step]').dataset.step;

    this.productVariantIds = JSON.parse(window.shippingBar.productIds);
    this.giftAmount = Number(window.shippingBar.giftAmount);
    this.shippingAmount = Number(window.shippingBar.shippingAmount);

    const url = new URL(location.href);
    this.funnelCustomStep = document.querySelector('#funnel-page__position-custom');

    this.bindEvents();
    this.hasChoosenEcoPackVariantId = url.searchParams.get('product_variant');
    if (this.hasChoosenEcoPackVariantId) {
      this.productVariant = this.hasChoosenEcoPackVariantId ?? false;
      this.preselectDefaultVariant(this.productVariant);
    }

    if (url.searchParams.get('product_color')) {
      this.preselectColor = decodeURIComponent(url.searchParams.get('product_color'));

      this.productVariant = document.querySelector(`.funnel-step__variant-list [data-variant-title="${this.preselectColor}"]`);
      this.preselectDefaultVariant(this.productVariant.value);
    }
    if (!this.hasChoosenEcoPackVariantId || !url.searchParams.get('product_color')) {
      this.preselectDefaultVariant(false);
    }
  }

  adjustHeight() {
    let headerElement = this.querySelector('header');
    let containerElement = this.querySelector('.funnel-page__step-container');
    let containerStickyElement = this.querySelector('.funnel-page__step-container_resize');
    let footerElement = this.querySelector('footer');

    if (containerStickyElement) {
      containerElement.style.height = window.innerHeight - headerElement.offsetHeight - footerElement.offsetHeight - 1 + 'px';
      containerElement.style.marginTop = headerElement.offsetHeight + 'px';
    }

    if (!containerStickyElement) {
      const allSteps = this.querySelectorAll('[data-step]');

      allSteps.forEach((step) => {
        if (step.getAttribute('data-step') == this.currentStep) {
          const elementHeight =
            step.querySelector('.funnel-page__inner').offsetHeight > 510 ? step.querySelector('.funnel-page__inner').offsetHeight : 510;

          const minWidth = window.innerHeight - headerElement.offsetHeight - footerElement.offsetHeight;

          containerElement.style.height = elementHeight + 'px';

          elementHeight < minWidth
            ? footerElement.classList.add('funnel-page__footer_sticky')
            : footerElement.classList.remove('funnel-page__footer_sticky');
        }
      });
    }
  }

  bindEvents() {
    this.addEventListener('click', this.onFilterOutsideClick.bind(this));

    this.ingardenColorElement.forEach((variantRadio) => {
      variantRadio.addEventListener('click', this.onVariantColorChange.bind(this));
    });

    this.productFilterButton.addEventListener('click', this.toggleFilterBody.bind(this));
    // this.productFilterButton.addEventListener('click', this.onFilterButtonClick.bind(this));
    document.body.addEventListener('click', this.offFilterButton.bind(this));
    this.productFilterButtonClose.addEventListener('click', this.closeFilterBody.bind(this));

    this.productFilterCheckBox.forEach((filterCheckbox) => {
      filterCheckbox.addEventListener('click', this.filterProductList.bind(this));
    });
    // this.productFilterSaveButton.addEventListener('click', this.onFilterSaveButtonClick.bind(this));
    this.productFilterResetButton.addEventListener('click', this.onFilterResetButtonClick.bind(this));

    this.nextButton.addEventListener('click', this.onNextButtonClick.bind(this));
    this.checkoutButton.addEventListener('click', this.onCheckoutButtonClick.bind(this));
    this.backButton.addEventListener('click', this.onBackButtonClick.bind(this));
    this.wrapperElement.addEventListener('change', this.onInputChange.bind(this));

    window.addEventListener('cart:updated', this.onCartUpdated.bind(this));

    if (window.matchMedia('only screen and (max-width: 749px)').matches) {
      document.addEventListener('scroll', (event) => {
        if (!document.querySelector('footer#funnel-page').classList.contains('active')) {
          document.querySelector('footer#funnel-page').classList.add('active');
        }
      });
    }
  }

  async preselectDefaultVariant(defaultVariant) {
    const variantList = document.querySelector('.funnel-step__variant-list');
    let selectedVariant = variantList.dataset.selectedVariant;

    const radioButtons = document.querySelectorAll('.variant-list__item input[type="radio"]');

    if (defaultVariant) {
      await this.clearCart();
      this.querySelector(`[value="${defaultVariant}"]`).click();
      this.nextButton.click();
      return;
    }

    const cartData = await fetchCart();
    const cartItems = cartData.items;
    cartItems.forEach((item) => {
      if (item.properties !== null) {
        selectedVariant = item.properties.baseVariant;
        variantList.dataset.selectedVariant = item.properties.baseVariant;
      }
    });

    if (selectedVariant) {
      this.querySelector(`[value="${selectedVariant}"]`).click();
    } else {
      const heroImageSrc = radioButtons[0].dataset.heroImg;
      this.updateHeroImg(heroImageSrc, 1, radioButtons[0].dataset.heroImgSmall);
    }
  }

  async clearCart() {
    const cartData = await fetchCart();
    const cartItems = cartData.items;
    let updates = {};
    cartItems.forEach((item) => {
      updates[item.id] = 0;
    });

    const body = JSON.stringify({ updates });

    await updateCart(body);
  }

  ekoPackQtyBindEvent() {
    const ekoPackQtyInput = document.querySelectorAll(`.subscription-switcher__product-list input[type="number"]`);
    ekoPackQtyInput.forEach((qtyInput) => {
      qtyInput.value = 0;
      qtyInput.addEventListener('change', this.onEkoPackQtyChange.bind(this));
    });

    const ekoPackItems = document.querySelectorAll(`.subscription-switcher__product-list .open-cart-item`);
    ekoPackItems.forEach((ekoPackItem) => {
      ekoPackItem.addEventListener('click', this.onEkoPackItemClick.bind(this));
    });
  }

  onEkoPackQtyChange(event) {
    const addedQty = this.calculateAddedQty();
    if (addedQty == this.availableQty) {
      this.nextButton.removeAttribute('disabled');
      this.disableProductAvailability();
    }
    if (addedQty < this.availableQty) {
      this.nextButton.setAttribute('disabled', true);
      this.enableProductAvailability();
    }
  }

  onEkoPackItemClick(event) {
    event.preventDefault();
    let element = event.target;
    if (!element.classList.contains('open-cart-item')) {
      element = element.closest('.open-cart-item');
    }
    const packImage = element.dataset.ekoPackImage;
    this.updateHeroImg(packImage, 2, undefined, 'image-superfood');

    const superfoodTitle = element.dataset.title;
    const superfoodDesc = element.dataset.description;
    // update mobile info
    this.querySelector('.funnel-step__superfood .funnel-step__superfood-title').innerHTML = superfoodTitle;
    this.querySelector('.funnel-step__superfood .funnel-step__superfood-desc').innerHTML = superfoodDesc;

    // update desktop info
    document.querySelector('.funnel-page-wrapper .funnel-page-title').innerHTML = superfoodTitle;

    if (document.querySelector('.funnel-page-wrapper .funnel-page-info .funnel-step__caption') != null) {
      document.querySelector('.funnel-page-wrapper .funnel-page-info .funnel-step__caption').innerHTML = superfoodDesc;
    }

    this.querySelector('.funnel-step__superfood').classList.remove('hidden');
  }

  resetEkoPackSelectedQty() {
    const ekoPackQtyInput = document.querySelectorAll(`.subscription-switcher__product-list input[type="number"]`);
    ekoPackQtyInput.forEach((qtyInput) => {
      qtyInput.value = 0;
      qtyInput.dispatchEvent(new Event('change'));
    });
  }

  calculateAddedQty() {
    const ekoPackQtyInput = document.querySelectorAll(`.subscription-switcher__product-list input[type="number"]`);
    let qty = 0;
    ekoPackQtyInput.forEach((qtyInput) => {
      qty += parseInt(qtyInput.value);
    });

    return qty;
  }

  disableProductAvailability() {
    const quantityInputs = document.querySelectorAll(`.subscription-switcher__product-list quantity-input`);
    let input = false;
    quantityInputs.forEach((quantityInput) => {
      input = quantityInput.querySelector('input');
      quantityInput.querySelector('button[name="plus"]').disabled = true;
      if (parseInt(input.value) == 0) {
        quantityInput.querySelector('button[name="minus"]').disabled = true;
      }
    });
  }

  enableProductAvailability() {
    const quantityInputs = document.querySelectorAll(`.subscription-switcher__product-list quantity-input`);
    quantityInputs.forEach((quantityInput) => {
      quantityInput.querySelector('button[name="plus"]').disabled = false;
      quantityInput.querySelector('button[name="minus"]').disabled = false;
    });
  }

  onVariantColorChange(event) {
    const input = event.target;
    if (input.getAttribute('data-checked') === `checked`) {
      return;
    }
    this.querySelector(`.funnel-step__variant-list`).dataset.selectedVariant = input.value;

    this.selectedVariantTitle = input.dataset.variantTitle;

    const prevChecked = input.getAttribute('data-checked');
    const radioButtons = document.querySelectorAll('.variant-list__item input[type="radio"]');

    radioButtons.forEach((btn) => {
      if (btn.getAttribute('data-checked') === 'checked' || btn.getAttribute('checked') === 'true') {
        const prevLabel = btn.parentElement;
        prevLabel.style.backgroundColor = 'transparent';
      }
      btn.removeAttribute('data-checked');
    });

    const label = input.parentElement;
    label.style.backgroundColor = label.dataset.color;

    const activeLabelTag = label.getElementsByClassName('variant-list__item-label')[0];
    activeLabelTag.style.backgroundColor = label.dataset.color;

    window.localStorage.setItem('funnel-selected-variant-color', label.dataset.color);
    if (!prevChecked) {
      input.setAttribute('data-checked', 'checked');
    } else {
      input.checked = false;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.setVariantHeroImage();
    if (!document.querySelector('footer#funnel-page').classList.contains('active')) {
      document.querySelector('footer#funnel-page').classList.add('active');
    }
  }

  onFilterOutsideClick(event) {
    // if (!this.querySelector('.funnel-filters-drawer').classList.contains('active')) {
    //   return;
    // }
    // const available = ['button', 'rect', 'path'];
    // const filterList = document.querySelector('.funnel-filters-drawer');
    // const withinBoundariesList = event.composedPath().includes(filterList);
    // if (!available.includes(event.target.tagName) && !withinBoundariesList) {
    //   this.productFilterSaveButton.click();
    // }
  }

  onFilterButtonClick(event) {
    // const filterButton = this.querySelector('.funnel-step__funnel-filters');
    // const filterBody = this.querySelector('#funnel-filters-drawer');
    // if (filterButton.getAttribute('aria-expanded') === 'false') {
    //   this.querySelector('.funnel-filters-drawer').classList.add('active');
    //   filterButton.setAttribute('aria-expanded', true);
    // }
    // if (event.target.classList.contains('funnel-step__funnel-filters')) {
    //   filterButton.setAttribute('aria-expanded', false);
    //   this.querySelector('.funnel-filters-drawer').classList.remove('active');
    // }
  }

  toggleFilterBody(event) {
    event.stopPropagation();
    this.productFilterButton.parentElement.classList.toggle('opened');
    document.body.classList.toggle('disabled-scroll');
    document.documentElement.classList.toggle('disabled-scroll');
    const funnelStepWrap = this.querySelectorAll('.funnel-step');
    funnelStepWrap.forEach((wrap) => {
      wrap.scroll({ top: 0, behavior: 'smooth' });
    });
    window.scrollTo(0, 0);
  }

  closeFilterBody(event) {
    event.stopPropagation();
    this.productFilterButton.parentElement.classList.remove('opened');
    document.body.classList.remove('disabled-scroll');
    document.documentElement.classList.remove('disabled-scroll');
  }

  offFilterButton(event) {
    if (!event.target.closest('#funnel-filters-drawer')) {
      if (this.productFilterButton.parentElement.classList.contains('opened')) {
        this.productFilterButton.parentElement.classList.remove('opened');
        document.body.classList.remove('disabled-scroll');
        document.documentElement.classList.remove('disabled-scroll');
      }
    }
  }

  filterProductList(event) {
    const filterTag = event.target.value;
    // Remove current tag
    const checkCurrent = this.activeProductFilter.indexOf(filterTag);
    if (checkCurrent > -1) this.activeProductFilter.splice(checkCurrent, 1);
    if (event.target.checked) this.activeProductFilter.unshift(filterTag);

    // event.target.checked ?  this.activeProductFilter.unshift(filterTag) : this.activeProductFilter.pop(filterTag);
    // this.activeProductFilter.push(filterTag)

    const productList = this.querySelectorAll(`.subscription-switcher__product-list cart-item`);
    let productTags = [];
    let productCompareId = [];

    productList.forEach((product) => {
      productTags = product.dataset.tags.split(',');
      const findTags = productTags.includes(filterTag);

      // if (productTags.includes(filterTag)) {
      //   event.target.checked ? this.activeProducts.push(product.dataset.id) : this.activeProducts.pop(filterTag);
      // }

      if (findTags) event.target.checked ? this.activeProducts.push(product.dataset.id) : productCompareId.push(product.dataset.id);
    });

    if (!event.target.checked) {
      productCompareId.forEach((id) => {
        const findCompareId = this.activeProducts.indexOf(id);
        if (findCompareId > -1) this.activeProducts.splice(findCompareId, 1);
      });
    }

    this.onActiveProductFilter();
    this.toggleProductList(productList);
    this.closeFilterBody(event);
  }

  toggleProductList(productList) {
    const availableProduct = [...new Set(this.activeProducts)];

    productList.forEach((product) => {
      let productId = product.dataset.id;

      if (this.activeProductFilter.length > 0 && !availableProduct.includes(productId)) {
        product.classList.add('hidden');
        product.parentElement.classList.add('hidden');
      } else {
        product.classList.remove('hidden');
        product.parentElement.classList.remove('hidden');
      }
    });
  }

  onFilterSaveButtonClick() {
    this.productFilterButton.click();
  }

  onFilterResetButtonClick() {
    this.activeProductFilter = [];
    this.activeProducts = [];
    const productList = this.querySelectorAll(`.subscription-switcher__product-list cart-item`);
    productList.forEach((product) => {
      product.classList.remove('hidden');
      product.parentElement.classList.remove('hidden');
    });

    this.productFilterCheckBox.forEach((filterCheckbox) => {
      filterCheckbox.checked = false;
    });
    this.productFiltersShowActive.classList.remove('show');
  }

  onActiveProductFilter() {
    const list = this.querySelector('.funnel-step__funnel-active-filters-list');
    const items = this.querySelectorAll('.funnel-step__funnel-active-filters-item');
    if (items.length >= 0) items.forEach((item) => item.remove());
    this.productFiltersShowActive.classList.remove('show');

    if (this.activeProductFilter.length > 0) {
      this.productFiltersShowActive.classList.add('show');

      this.activeProductFilter.forEach((activeFilter) => {
        const li = document.createElement('li');
        li.classList.add('funnel-step__funnel-active-filters-item');
        li.innerHTML = activeFilter;
        li.dataset.value = activeFilter;
        list.append(li);
      });

      const items = this.querySelectorAll('.funnel-step__funnel-active-filters-item');

      items.forEach((item) => {
        item.addEventListener('click', () => this.clickActiveProductFilter(item));
      });
    }
  }

  clickActiveProductFilter(item) {
    this.productFilterCheckBox.forEach((filterCheckbox) => {
      if (filterCheckbox.value === item.dataset.value) {
        const filterTag = item.dataset.value;

        const productList = this.querySelectorAll(`.subscription-switcher__product-list cart-item`);
        let productTags = [];
        let productCompareId = [];
        productList.forEach((product) => {
          productTags = product.dataset.tags.split(',');
          const findTags = productTags.includes(filterTag);
          if (findTags) productCompareId.push(product.dataset.id);
        });

        productCompareId.forEach((id) => {
          const findCompareId = this.activeProducts.indexOf(id);
          if (findCompareId > -1) this.activeProducts.splice(findCompareId, 1);
        });

        const currentTag = this.activeProductFilter.indexOf(item.dataset.value);
        this.activeProductFilter.splice(currentTag, 1);

        filterCheckbox.checked = false;
        this.toggleProductList(productList);
      }
    });

    item.remove();

    const checkItemsLength = this.querySelectorAll('.funnel-step__funnel-active-filters-item').length;
    if (checkItemsLength == 0) this.productFiltersShowActive.classList.remove('show');
  }

  onInputChange(event) {
    if (event.target.name === 'subscription') {
      this.onChangeSubscription(event);
      this.switchActivePlanDescription();
    }

    if (this.currentStep === this.lastStep) {
      let productAmount = [...this.querySelectorAll(`[data-step="${this.currentStep}"] input[type="number"]`)].reduce(
        (sum, current) => sum + Number(current.value),
        0
      );
      if (productAmount === 0) {
        this.nextButton.querySelector('span').textContent = this.nextButton.dataset.skip;
      } else {
        this.nextButton.querySelector('span').textContent = this.nextButton.dataset.next;
      }
    }

    if (this.currentStep === this.subscriptionStep && this.currentSubscription == 'membership') {
      this.updateSubscriptionText();
    }
  }

  onChangeSubscription(event) {
    this.currentSubscription = event.target.value;

    this.toggleSubscriptionText();
    this.toggleSubscriptionPrice();
    this.toggleSubscriptionPadPrice();
  }

  preSelectRefillPackProducts(planType) {
    const refillPackQtyInputs = this.querySelectorAll('.subscription-switcher__product-list .cart-item .quantity__input');

    refillPackQtyInputs.forEach((refillPackQtyInput) => {
      switch (planType) {
        case 'membership':
          if (refillPackQtyInput.dataset.subscribePreselect === 'true') {
            refillPackQtyInput.nextElementSibling.click();
          }
          break;
        case 'one-time':
          if (refillPackQtyInput.dataset.onetimePreselect === 'true') {
            refillPackQtyInput.nextElementSibling.click();
          }
          break;
        case 'bundle':
          if (refillPackQtyInput.dataset.bundlePreselect === 'true') {
            refillPackQtyInput.nextElementSibling.click();
          }
          break;
      }
    });
  }

  toggleSubscriptionPadPrice() {
    const subscriptionPadPriceElements = this.querySelectorAll('.subscription-switcher .pad-price');

    subscriptionPadPriceElements.forEach((el) => {
      el.innerHTML = this.currentSubscription === 'membership' ? el.dataset.subscribe : el.dataset.onetime;
    });
  }

  toggleSubscriptionPrice() {
    const subscriptionPriceElements = this.querySelectorAll('.subscription-switcher .cart-item__price');

    const reccuringPrice = this.querySelector('.subscription-switcher [data-reccuring-price]').dataset.reccuringPrice;
    const price = this.querySelector('.subscription-switcher [data-price]').dataset.price;

    const discountPriceHTML = `<span class="price--discount">${formatMoney(price)}</span>`;

    subscriptionPriceElements.forEach((el) => {
      const priceItem = el.querySelectorAll('span');

      if (priceItem.length === 2) {
        if (this.currentSubscription == 'membership') {
          priceItem[0].innerHTML = formatMoney(reccuringPrice);
          priceItem[0].insertAdjacentHTML('afterend', discountPriceHTML);
        } else {
          priceItem[0].innerHTML = formatMoney(price);
          priceItem[1].remove();
        }
      }
    });
  }

  toggleSubscriptionText() {
    const oneTimeTextElement = this.querySelector('.subscription-switcher__icon-item[data-one-time-text]');
    const subscriptionTextElement = this.querySelector('.subscription-switcher__icon-item[data-subscription-text]');
    const orderTextElement = this.querySelector('.subscription-switcher__icon-item[data-order-text]');

    if (oneTimeTextElement.classList.contains('active')) {
      oneTimeTextElement.classList.remove('active');
      subscriptionTextElement.classList.add('active');
    } else {
      subscriptionTextElement.classList.remove('active');
      orderTextElement.classList.remove('active');
      oneTimeTextElement.classList.add('active');
    }
  }

  updateSubscriptionText() {
    const orderTextElement = this.querySelector('.subscription-switcher__icon-item[data-order-text]');

    const amountElement = this.querySelector('.subscription-switcher [data-subscription-amount]');
    const shippingElement = this.querySelector('.subscription-switcher [data-subscription-shipping]');
    const totalElement = this.querySelector('.subscription-switcher [data-subscription-total]');

    const subscriptionElements = this.querySelectorAll(`[data-step="${this.subscriptionStep}"] cart-item input`);
    let subscriptionAmount = [...subscriptionElements].reduce((sum, current) => sum + Number(current.value), 0);

    if (subscriptionAmount > 0) {
      !orderTextElement.classList.contains('active') && orderTextElement.classList.add('active');

      amountElement.textContent = subscriptionAmount;

      subscriptionAmount = subscriptionAmount > 12 ? 12 : subscriptionAmount;
      shippingElement.textContent = getDateFromToday(subscriptionAmount * 30).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
      totalElement.innerHTML = formatMoney(this.subtotalArray[this.subscriptionStep]);
    } else {
      orderTextElement.classList.remove('active');
    }
  }

  async removeEkoPackProductFromCart() {
    const products = this.querySelectorAll(`.subscription-switcher__product-list cart-item input`);
    let data = {};

    products.forEach((el) => (data[el.dataset.variant] = 0));

    const body = JSON.stringify({
      updates: data,
    });

    await updateCart(body);
  }

  async onCartUpdated(event) {
    const sections = this.getSectionsToRender()
      .map((section) => section.section)
      .filter((el, index, self) => self.indexOf(el) === index)
      .join(',');
    const response = await getSectionContent(sections);

    this.renderSections(response);
  }

  renderSections(json) {
    this.getSectionsToRender().forEach((item) => {
      const elementToReplace = document.querySelectorAll(item.selector);
      const section = json[item.section] || (json.sections && json.sections[item.section]);
      // elementToReplace.forEach((el) => (el.innerHTML = getSectionInnerHTML(section, item.selector)));
    });
  }

  renderCartSections(json) {
    this.getCartSectionsToRender().forEach((item) => {
      const elementToReplace = document.querySelectorAll(item.selector);
      const section = json[item.section] || (json.sections && json.sections[item.section]);

      elementToReplace.forEach((el) => (el.innerHTML = getSectionInnerHTML(section, item.selector)));
    });
  }

  getSecondStepProductsAmount() {
    const subscriptionElements = this.querySelectorAll(`[data-step="${this.subscriptionStep}"] cart-item input`);
    return [...subscriptionElements]
      .filter((element) => this.productVariantIds.includes(Number(element.dataset.variant)))
      .reduce((sum, current) => sum + Number(current.value), 0);
  }

  getSectionsToRender() {
    return [
      {
        section: 'main-funnel-page',
        selector: '.subscription-switcher__product-list',
      },
    ];
  }

  getCartSectionsToRender() {
    return [
      {
        section: 'main-funnel-page',
        selector: '.funnel-cart',
      },
    ];
  }

  async addIngardenToCart() {
    // remove previous ingarden variant from cart
    await this.clearCart();

    const ingardenCartVariant = this.querySelector('.funnel-step__variant-list input:checked');
    let cartItems = [];

    cartItems.push({
      id: ingardenCartVariant.value,
      quantity: 1,
      properties: {
        baseVariant: ingardenCartVariant.value,
      },
    });

    const response = await addToCart(
      JSON.stringify({
        items: cartItems,
        sections: ['main-funnel-page'],
      })
    );

    this.renderSections(response);
  }

  async processRefillPackProduct() {
    await this.removeEkoPackProductFromCart();
    const activePlan = this.querySelector('.subscription-switcher__plan-list input:checked');

    // if selected bundle plan, first change ingarden variant in cart to bundle
    if (activePlan.value === 'bundle' || activePlan.value === 'membership') {
      await this.switchIngardenVariantByCurrentPlan(activePlan.value);
    }

    let currentInputElements = this.querySelectorAll(`.subscription-switcher__product-list cart-item input:not([name="subscription"])`);
    const extraInputElements = this.querySelectorAll('.funnel-step--3 cart-item .quantity__input');

    const subscriptionAmount = [...currentInputElements].reduce((sum, current) => sum + Number(current.value), 0);
    if (subscriptionAmount == 0) {
      return;
    }

    let items = [];
    let item = {};

    currentInputElements.forEach((el) => {
      if (el.value > 0) {
        item = {
          id: +el.dataset.variant,
          quantity: +el.value,
        };
        if (activePlan.value === 'membership') {
          item['selling_plan'] = JSON.parse(el.dataset.sellingPlans)[0];
        }
        //if (activePlan.value === 'bundle') {
        //item['selling_plan'] = JSON.parse(el.dataset.sellingPlans)[4];
        //}
        items.push(item);
      }
    });

    extraInputElements.forEach((extraItem) => {
      if (extraItem.value > 0) {
        items.push({
          id: +extraItem.dataset.variant,
          quantity: +extraItem.value,
        });
      }
    });

    const response = await addToCart(
      JSON.stringify({
        items,
      })
    );
  }

  async switchIngardenVariantByCurrentPlan(activePlan) {
    const ingardenInCart = this.querySelector(`.funnel-step__variant-list`).dataset.selectedVariant;
    let newIngardenVariant = false;
    if (activePlan === 'bundle') {
      newIngardenVariant = this.querySelector(`.funnel-step__bundle-variant-list input[data-variant-title="${this.selectedVariantTitle}"]`);
    }
    if (activePlan === 'membership') {
      newIngardenVariant = this.querySelector(
        `.funnel-step__subscribe-variant-list input[data-variant-title="${this.selectedVariantTitle}"]`
      );
    }

    // remove prev ingarden from cart
    const body = JSON.stringify({
      updates: {
        [ingardenInCart]: 0,
      },
    });

    await updateCart(body);

    // add new to cart
    let items = [];

    items.push({
      id: newIngardenVariant.value,
      quantity: 1,
      properties: {
        baseVariant: ingardenInCart,
      },
    });

    await addToCart(
      JSON.stringify({
        items: items,
      })
    );
  }

  calculatePlanPrices() {
    if (this.planPricesInit) {
      return;
    }
    const variantPrice = document.querySelector(`.funnel-step__variant-list input:checked`).dataset.price;
    const bundleProductPrice = document.querySelector(`.funnel-step__bundle-variant-list input`);
    const membershipProductPrice = document.querySelector(`.funnel-step__subscribe-variant-list input`);

    const firstProduct = document.querySelector(`.subscription-switcher__product-list input`);
    if (firstProduct !== null && firstProduct !== undefined) {
      const membershipPrice = membershipProductPrice.dataset.price * 1 + firstProduct.dataset.reccuringPrice * 2;
      const originalPrice = variantPrice * 1 + firstProduct.dataset.price * 2;
      const bundlePrice = bundleProductPrice.dataset.price * 1 + firstProduct.dataset.price * 6;

      const discount = (firstProduct.dataset.reccuringPrice * 100) / firstProduct.dataset.price;

      const membershipPriceHtml = `
      <span class="price--membership-original">(${formatMoney(originalPrice)})</span>
      <span class="price--membership-discount">(${formatMoney(membershipPrice)})</span>
      `;

      const oneTimePriceHtml = `<span class="price--original">(${formatMoney(originalPrice)})</span>`;
      const bundlePriceHtml = `<span class="price--original">(${formatMoney(bundlePrice)})</span>`;

      //document.querySelector('.subscription-switcher__discount').innerHTML = `-${100 - Math.round(discount)}%`;
      //document.querySelector('.subscription-switcher__plan .membership').innerHTML += membershipPriceHtml;
      //document.querySelector('.subscription-switcher__plan .one-time').innerHTML += oneTimePriceHtml;
      //document.querySelector('.subscription-switcher__plan .bundle').innerHTML += bundlePriceHtml;
      this.planPricesInit = true;
    }
  }

  async onNextButtonClick(event) {
    this.nextButton.querySelector('.loading-overlay').classList.remove('hidden');
    this.nextButton.querySelector('span').classList.add('hidden');

    switch (this.localStep) {
      //after select kit product step
      case 0:
        await this.addIngardenToCart();

        this.ekoPackQtyBindEvent();
        this.nextButton.querySelector('span').textContent = this.nextButton.dataset.selectPlan;
        this.changeSlide('next');
        this.localStep++;
        this.calculatePlanPrices();
        this.activateStep(2);
        this.funnelCustomStep.innerHTML = `<span data-current-step>2</span>/4`;
        this.switchActivePlanDescription();
        this.querySelector('.funnel-step__guarantee-and-accordion--step-2').classList.remove('hidden');

        break;

      // after select plan step
      case 1:
        this.activateStep(3);
        this.resetEkoPackSelectedQty();
        const activePlan = this.querySelector('.subscription-switcher__plan-list input:checked');
        this.preSelectRefillPackProducts(activePlan.value);
        this.checkProductPriceBadge(activePlan.value);

        //this.nextButton.setAttribute('disabled', false);
        this.nextButton.removeAttribute('disabled');
        this.nextButton.querySelector('span').textContent = this.nextButton.dataset.selectSuperfood;
        const stepTitle = this.querySelector('.funnel-step--2 .funnel-step__title');
        const selectedPlanTitle = activePlan.value === 'bundle' ? stepTitle.dataset.refillBundleTitle : stepTitle.dataset.refillTitle;
        stepTitle.innerHTML = selectedPlanTitle;

        // switch nutrition product
        const nutritionCoaching = this.querySelector('.funnel-step--3 .funnel-step__product-list .nutrition-coaching');
        const nutritionCoachingFree = this.querySelector('.funnel-step--3 .funnel-step__product-list .nutrition-coaching-free');
        if(nutritionCoaching && nutritionCoachingFree){
          if (activePlan.value === 'membership') {
            nutritionCoaching.classList.add('hidden');
            nutritionCoachingFree.classList.remove('hidden');
          } else {
            nutritionCoaching.classList.remove('hidden');
            nutritionCoachingFree.classList.add('hidden');
          }
        }

        this.querySelector('.funnel-step--2 .funnel-step__icon-list').classList.add('hidden');
        this.querySelector('.subscription-switcher__plan-list').classList.add('hidden');
        this.querySelector('.subscription-switcher__product-list').classList.remove('hidden');
        this.querySelector('.funnel-step__superfood-refill-info').classList.remove('hidden');
        this.querySelector('.funnel-step__funnel-filters').classList.remove('hidden');

        this.querySelector('.funnel-step__guarantee-and-accordion--step-2').classList.add('hidden');
        this.querySelector('.funnel-step__guarantee-and-accordion--step-3').classList.remove('hidden');

        this.querySelector('.subscription-switcher__product-list a.open-cart-item').click();

        this.localStep++;
        this.funnelCustomStep.innerHTML = `
              <span data-current-step>3</span>/4
            `;
        if (typeof loadReviewsIoRatingSnippets === 'function') {
          loadReviewsIoRatingSnippets();
        }
        break;

      // after select refill pack product step
      case 2:
        document.querySelector(`.funnel-page-large-screen .funnel-page-wrapper`).classList.add('hidden');
        this.activateStep(4);
        this.nextButton.querySelector('span').textContent = this.nextButton.dataset.last;
        this.changeSlide('next');
        this.localStep++;

        // update hero image
        if (window.innerWidth > 750) {
          const heroImg = new Image();
          let heroContainerLarge = document.querySelector(`.funnel-page-large-screen .funnel-image`);
          heroImg.addEventListener(
            'load',
            () => {
              heroContainerLarge.innerHTML = '';
              heroContainerLarge.appendChild(heroImg);
            },
            false
          );

          heroImg.src = heroContainerLarge.dataset.extraImage;
        }

        break;

      case 3:
        // last step - go to checkout
        await this.processRefillPackProduct();
        location.href = '/checkout?step=contact_information';
        break;

      default:
        break;
    }

    this.nextButton.querySelector('.loading-overlay').classList.add('hidden');
    this.nextButton.querySelector('span').classList.remove('hidden');

    setTimeout(function () {
      const funnelStepWrap = document.querySelectorAll('.funnel-step');
      funnelStepWrap.forEach((wrap) => {
        wrap.scroll({ top: 0, behavior: 'smooth' });
      });
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, '250');
  }

  activateStep(step) {
    const steps = this.querySelectorAll('.funnel-page__progress .step');
    const progressBar = this.querySelector('.funnel-page__progress-bar');
    const activeStep = this.querySelector('.funnel-page__progress .step.active');
    const nextStep = this.querySelector('.funnel-page__progress [data-funnel-step="' + step + '"]');
    activeStep.classList.add('complete');
    activeStep.classList.remove('active');
    nextStep.classList.add('active');
    // calc progress bar width
    progressBar.style.width = ((step - 1) / (steps.length - 1)) * 100 + '%';

    // desktop progress steps
    const progressActiveDesktop = document.querySelector('.funnel-page-progress [data-step="' + step + '"]');
    const progressPreviousDesktop = document.querySelector('.funnel-page-progress [data-step="' + (step - 1) + '"]');
    progressActiveDesktop.classList.add('active');
    progressPreviousDesktop.classList.add('passed');
  }

  prepareCartPage() {
    document.querySelector('.funnel-page-container').classList.add('cart');
    this.classList.add('cart');
    this.backButton.classList.add('hidden');
    this.nextButton.classList.add('hidden');
    this.checkoutButton.classList.remove('hidden');
    this.querySelector('.funnel-page__position').classList.add('hidden');
    this.querySelector('.funnel-page__summary').classList.remove('hidden');
    this.showCartSubtotal();
    this.switchCartDescription();
  }

  switchCartDescription() {
    const activePlan = this.querySelector('.funnel-step--2 .subscription-switcher__plan-list input:checked');
    const cartPlanDesc = this.querySelector('.funnel-step__cart_item-title');

    switch (activePlan.value) {
      case 'membership':
        cartPlanDesc.innerHTML = `${cartPlanDesc.dataset.membershipTitle}<p>${cartPlanDesc.dataset.membershipInitial}</p>`;
        break;
      case 'one-time':
        cartPlanDesc.innerHTML = cartPlanDesc.dataset.oneTimeTitle;
        break;
      case 'bundle':
        cartPlanDesc.innerHTML = cartPlanDesc.dataset.bundleTitle;
        break;
    }
  }

  showCartSubtotal() {
    this.querySelector('.funnel-page__subtotal').classList.remove('hidden');
    const subtotal = this.querySelector('[data-cart-total]');
    this.querySelector('[data-subtotal]').innerHTML = formatMoney(subtotal.dataset.cartTotal);
  }

  async onCheckoutButtonClick() {
    location.href = '/checkout?step=contact_information';
  }

  async onBackButtonClick(event) {
    switch (this.localStep) {
      case 1:
        this.backToStep(1);
        this.nextButton.querySelector('span').textContent = this.nextButton.dataset.first;
        this.changeSlide('back');
        this.funnelCustomStep.innerHTML = `
          <span data-current-step>1</span>/3
        `;
        document.querySelector(`.funnel-page-large-screen .funnel-page-wrapper`).classList.add('hidden');
        break;
      case 2:
        this.funnelCustomStep.innerHTML = `
          <span data-current-step>2</span>/3
        `;
        const stepTitle = this.querySelector('.funnel-step--2 .funnel-step__title');
        stepTitle.innerHTML = stepTitle.dataset.planTitle;

        this.querySelector(`.funnel-step--2 .funnel-step__superfood`).classList.add('hidden');

        this.switchActivePlanDescription();

        this.querySelector('.subscription-switcher__plan-list').classList.remove('hidden');
        this.querySelector('.subscription-switcher__product-list').classList.add('hidden');
        this.querySelector('.funnel-step__superfood-refill-info').classList.add('hidden');

        this.querySelector('.funnel-step__guarantee-and-accordion--step-2').classList.remove('hidden');
        this.querySelector('.funnel-step__guarantee-and-accordion--step-3').classList.add('hidden');

        // if (this.querySelector('.funnel-filters-drawer').classList.contains('active')) {
        //   this.querySelector('.filter-action-buttons [data-save]').click();
        // }
        this.querySelector('.funnel-step__funnel-filters').classList.add('hidden');
        this.nextButton.removeAttribute('disabled');
        this.nextButton.querySelector('span').textContent = this.nextButton.dataset.selectPlan;
        // document.querySelector(`.funnel-page-large-screen .funnel-page-wrapper`).classList.remove('hidden');
        this.backToStep(2);
        break;
      case 3:
        this.backToStep(3);
        this.nextButton.querySelector('span').textContent = this.nextButton.dataset.selectSuperfood;
        this.changeSlide('back');
    }

    this.localStep--;
  }

  backToStep(toStep) {
    const steps = this.querySelectorAll('.funnel-page__progress .step');
    const progressBar = this.querySelector('.funnel-page__progress-bar');
    const activeStep = this.querySelector('.funnel-page__progress .step.active');
    const newStep = this.querySelector('.funnel-page__progress [data-funnel-step="' + toStep + '"]');

    activeStep.classList.remove('active');

    newStep.classList.remove('complete');
    setTimeout(function () {
      newStep.classList.add('active');
      progressBar.style.width = ((toStep - 1) / (steps.length - 1)) * 100 + '%';
    }, '400');

    // desktop
    const progressActiveDesktop = document.querySelector('.funnel-page-progress [data-step="' + toStep + '"]');
    const progressPreviousDesktop = document.querySelector('.funnel-page-progress [data-step="' + (toStep + 1) + '"]');
    progressActiveDesktop.classList.add('active');
    progressActiveDesktop.classList.remove('passed');

    progressPreviousDesktop.classList.remove('active');
    setTimeout(function () {
      const funnelStepWrap = document.querySelectorAll('.funnel-step');
      funnelStepWrap.forEach((wrap) => {
        wrap.scroll({ top: 0, behavior: 'smooth' });
      });
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, '250');
  }

  changeSlide(direction) {
    switch (direction) {
      case 'next':
        this.currentStep = ++this.currentStep > this.lastStep ? this.lastStep : this.currentStep;
        break;
      case 'back':
        this.currentStep = --this.currentStep < 0 ? 0 : this.currentStep;
        break;
    }
    this.goToSlide(this.currentStep);
  }

  goToSlide(step) {
    this.wrapperElement.style.transform = `translateX(-${step * 100}%)`;
  }

  setVariantHeroImage() {
    const activeVariant = this.querySelector(`.funnel-step__variant-list`).dataset.selectedVariant;
    const selectedVariant = this.querySelector(`.funnel-step__variant-list [value="${activeVariant}"]`);
    const heroImageSrc = selectedVariant.dataset.heroImg;
    const heroImageSmallSrc = selectedVariant.dataset.heroImgSmall;

    this.updateHeroImg(heroImageSrc, 1, heroImageSmallSrc);
  }

  switchActivePlanDescription() {
    const allPlanDescription = this.querySelectorAll(`.funnel-step--2 .funnel-step__icon-item`);
    allPlanDescription.forEach((el) => {
      el.classList.add('hidden');
    });

    const allPlanLabels = this.querySelectorAll(`.funnel-step--2 .subscription-switcher__plan`);
    allPlanLabels.forEach((label) => {
      label.style.backgroundColor = 'transparent';
    });

    const activePlan = this.querySelector('.funnel-step--2 .subscription-switcher__plan-list input:checked');

    this.setActivePlanHeroImage(activePlan.value);

    switch (activePlan.value) {
      case 'membership':
        this.availableQty = this.membershipAvailableQty;
        break;
      case 'one-time':
        this.availableQty = this.oneTimeAvailableQty;
        break;
      case 'bundle':
        this.availableQty = this.bundleAvailableQty;
        break;
    }

    console.log("-------------testst---------------")
    console.log(activePlan.value)
    console.log("-------------testst---------------")
    const activePlanLabel = activePlan.parentElement;
    const activeIconItem = this.querySelector(`.funnel-step--2 .funnel-step__icon-item.${activePlan.value}`);
    activeIconItem.classList.remove('hidden');

    // large screen change text
    const html = `<div class="funnel-page-title">${activePlan.dataset.planTitle}</div>
      <div class="funnel-page-info">${activeIconItem.innerHTML}</div>`;
    document.querySelector('.funnel-page-large-screen .funnel-page-wrapper').innerHTML = html;
    // document.querySelector('.funnel-page-large-screen .funnel-page-wrapper').classList.remove('hidden');

    // small screen show text
    // this.querySelector('.funnel-step--2 .funnel-step__icon-list').classList.remove('hidden');
    this.querySelector(`.funnel-step--2 .funnel-step__icon-item.${activePlan.value}`).classList.remove('hidden');

    activePlanLabel.style.backgroundColor = window.localStorage.getItem('funnel-selected-variant-color');
    const funnelCart = document.querySelector('.funnel-page-container .funnel-cart');
    if (window.innerWidth > 750 && funnelCart !== null) {
      funnelCart.style.backgroundColor = window.localStorage.getItem('funnel-selected-variant-color');
    }

    // update plan prices
    const activeVariant = this.querySelector(`.funnel-step__variant-list`).dataset.selectedVariant;
    const selectedVariant = this.querySelector(`.funnel-step__variant-list [value="${activeVariant}"]`);
    const planPrices = this.querySelectorAll('.ingarden-plan-price');

    let useRegularPrice = true;
    if (selectedVariant.dataset.plasticPrice === 'true') {
      useRegularPrice = false;
    }
    planPrices.forEach((planPrice) => {
      if (useRegularPrice) {
        planPrice.innerHTML = planPrice.dataset.regularPrice;
      } else {
        planPrice.innerHTML = planPrice.dataset.plasticPrice;
      }
    });
  }

  checkProductPriceBadge(activePlan) {
    const cartItems = this.querySelectorAll('.cart-item');
    cartItems.forEach((item) => {
      const priceBadges = item.querySelectorAll('.product-price-badge__item');

      if (priceBadges.length > 0) {
        priceBadges.forEach((priceBadge) => {
          if (activePlan == priceBadge.dataset.priceValue) {
            priceBadge.classList.remove('hidden');
          } else {
            priceBadge.classList.add('hidden');
          }
        });
      }
    });
  }

  setActivePlanHeroImage(activePlan) {
    const activeVariant = this.querySelector(`.funnel-step__variant-list`).dataset.selectedVariant;
    const selectedVariant = this.querySelector(`.funnel-step__variant-list [value="${activeVariant}"]`);
    let heroImage = ``;

    switch (activePlan) {
      case 'membership':
        heroImage = selectedVariant.dataset.subscribePlanImg;
        break;
      case 'one-time':
        heroImage = selectedVariant.dataset.oneOffPlanImg;
        break;
      case 'bundle':
        heroImage = selectedVariant.dataset.bundlePlanImg;
        break;
    }
    if (heroImage) {
      this.updateHeroImg(heroImage, 2, undefined, 'image-variant-list');
    }
  }

  updateHeroImg(heroImageSrc, step, smallImage = false, classList) {
    const heroImg = new Image();
    let heroContainer = this.querySelector(`.funnel-step--${step} .funnel-step__hero-img`);
    let heroContainerLarge = document.querySelector(`.funnel-page-large-screen .funnel-image`);
    ['image-superfood', 'image-variant-list'].map((e) => heroContainer.classList.remove(e));
    if (classList !== undefined) {
      heroContainer.classList.add(classList);
      heroImg.classList.add(classList);
    }

    heroImg.addEventListener(
      'load',
      () => {
        if (window.innerWidth > 750) {
          heroContainerLarge.innerHTML = '';
          heroContainerLarge.appendChild(heroImg);
        } else {
          heroContainer.innerHTML = '';
          heroContainer.appendChild(heroImg);
        }
      },
      false
    );
    if (window.innerWidth < 750 && smallImage) {
      heroImg.src = smallImage;
    } else {
      heroImg.src = heroImageSrc;
    }
  }
}

customElements.define('funnel-page', FunnelPage);
